/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_UnauthorizedInputs */



/**
* | output |
* | --- |
* | "Incorrect email or password" |
*
* @param {Error_UnauthorizedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_unauthorized = /** @type {((inputs?: Error_UnauthorizedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_UnauthorizedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Incorrect email or password")
	return /** @type {LocalizedString} */ ("Email ou mot de passe incorrect")
});